module.exports = __webpack_public_path__ + "img/sv62.db78c66d.svg";